<template>
  <v-app class="noselect">

    <v-navigation-drawer
    class="hidden-sm-and-up"
    stateless
    right
    hide-overlay
    v-model="drawer"
  app
>
<!--
<v-btn v-if="degreeKind === 'admin'" to="/admin" round color="yellow" dark><span style="color: black">Admin</span></v-btn>
<v-btn v-if="degreeKind === 'teacher'" to="/alunos" round color="yellow" dark><span style="color: black">Alunos</span></v-btn>

      <v-btn v-if="isProfileLoaded === true && degreeKind === 'teacher'" to="/mensagens" round color="yellow" dark>
        <v-badge color="black" v-model="messageShow" right>
        <span slot="badge">{{messagesTotal}}</span>
        <span style="color: black">Mensagens</span>
      </v-badge>
      </v-btn>
-->
  <v-list>
    <v-btn v-if="this.language == 'EN'" block color="blue-grey lighten-5" @click="closeDrawer">
        <v-icon >close</v-icon><span>Close</span>
    </v-btn>

    <v-btn v-if="this.language == 'PT'" block color="blue-grey lighten-5" @click="closeDrawer">
        <v-icon >close</v-icon><span>Fechar</span>
    </v-btn>

    <v-list-tile v-if="false" to="/entrar" @click="closeDrawer">
      <v-list-tile-content>
        <v-list-tile-title>Entrar</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="false" to="/registrar" @click="closeDrawer">
      <v-list-tile-content>
        <v-list-tile-title>Registrar-se</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="gotoscroll('top'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Home</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'PT'" @click="gotoscroll('top'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Inicial</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="gotoscroll('solucoes'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Solutions</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'PT'" @click="gotoscroll('solucoes'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Soluções</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="gotoscroll('quem_somos'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Who</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'PT'" @click="gotoscroll('quem_somos'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Quem somos</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="gotoscroll('parceiros'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Partners</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'PT'" @click="gotoscroll('parceiros'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Parceiros</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="gotoscroll('contato'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Contact</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'PT'" @click="gotoscroll('contato'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Contato</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="entrarLoginWindow(); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Log In</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'PT'" @click="entrarLoginWindow(); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Entrar</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="changeLanguage('PT'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Português</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'PT'" @click="changeLanguage('EN'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>English</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
<!--
    <v-list-tile v-if="this.language == 'PT'" @click="changeLanguage('EN'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>English</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="this.language == 'EN'" @click="changeLanguage('PT'); closeDrawer()" dark>
      <v-list-tile-content>
        <v-list-tile-title>Português</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  -->

<!--

    <v-btn v-if="this.language == 'EN'" flat  small @click="gotoscroll('solucoes')"  color="white">Solutions</v-btn>
    <v-btn v-if="this.language == 'PT'" flat  small @click="gotoscroll('solucoes')"  color="white">Soluções</v-btn>
    <v-btn v-if="this.language == 'EN'" flat small @click="gotoscroll('quem_somos')"  color="white">Who</v-btn>
    <v-btn v-if="this.language == 'PT'" flat small @click="gotoscroll('quem_somos')"  color="white">Quem somos</v-btn>
    <v-btn v-if="this.language == 'EN'" flat small @click="gotoscroll('parceiros')"  color="white">Partners</v-btn>
    <v-btn v-if="this.language == 'PT'" flat small @click="gotoscroll('parceiros')"  color="white">Parceiros</v-btn>
    <v-btn v-if="this.language == 'EN'" flat small @click="gotoscroll('contato')"  color="white">Contact</v-btn>
    <v-btn v-if="this.language == 'PT'" flat small @click="gotoscroll('contato')"  color="white">Contato</v-btn>

-->

    <v-list-tile dark v-if="degreeKind === 'teacher'" to="/alunos" @click="closeDrawer">
      <v-list-tile-content>
        <v-list-tile-title>Alunos</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile dark v-if="degreeKind === 'admin'" to="/admin" @click="closeDrawer">
      <v-list-tile-content>
        <v-list-tile-title>Admin</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile dark v-if="isProfileLoaded === true && degreeKind === 'teacher'" to="/mensagens" @click="closeDrawer">
      <v-badge color="black" v-model="messageShow" right>
      <span slot="badge">{{messagesTotal}}</span>
      <span style="color: black">Mensagens</span>
    </v-badge>
    </v-list-tile>

    <v-list-tile dark v-if="isProfileLoaded && degreeKind === 'teacher' || degreeKind === 'student'" to="/conta" @click="closeDrawer">
      <v-list-tile-content>
        <v-list-tile-title>Conta</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-btn v-if="isAuthenticated" block dark color="blue-grey" @click="logout">
      <div>Sair da conta</div>
    </v-btn>

  </v-list>
</v-navigation-drawer>



    <navigation></navigation>

      <v-content class="background" >
        <router-view class="pa-0"/>
      </v-content>

      <Footer/>

  </v-app>
</template>

<script>
import { NAV_DRAWER, LANGUAGE, ENTRAR_WINDOW, ENTRARLOGIN } from './store/actions/navigation'
import Navigation from './components/navigation'
import Footer from './components/footer/index.vue'
import { mapGetters, mapState } from 'vuex'
import * as VueScrollTo  from 'vue-scrollto'

export default {
  data () {
    return {
      clipped: false,
      drawerx: false,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js'
    }
  },
  computed: {
    ...mapGetters(['degreeKind', 'messageShow', 'getProfile', 'isAuthenticated', 'isProfileLoaded','janelaLateral','getLanguage', 'getLoginWindow']),
    ...mapState({
      language: state => state.navigation.language,
      loginWindows: state => state.navigation.loginWindow,
      messagesTotal: state => state.messages.userMessagesTotal,
      messageShow: state => state.messages.messageShow,
      authLoading: state => state.auth.status === 'loading',
      name: state => `${state.user.profile.title} ${state.user.profile.name}`,
    }),
    drawer: {
        get () {
          //_x_console.log('get drawer state: '+this.janelaLateral)
          return this.janelaLateral
        },
        set (state) {
          if(state){
            //_x_console.log('set drawer state: '+state)
            //this.$store.dispatch(NAV_DRAWER)
          }
        }
      }
  },    methods: {
      logout: function () {
        this.closeDrawer();
      },
      closeDrawer: function () {
        this.drawerx = true
        this.$store.dispatch(NAV_DRAWER)
      },
      entrarLogin: function (e) {
        this.$store.dispatch(ENTRARLOGIN,e)
      },
      entrarLoginWindow: function () {
          this.$store.dispatch(ENTRAR_WINDOW,true)
      },
      gotoscroll: function (e) {
        if(e==='top'){
          VueScrollTo.scrollTo('#top', 1000,{easing: 'ease-in-out', offset: -100, cancelable: true})
        }else if(e==='solucoes'){
          VueScrollTo.scrollTo('#solucoes', 1000,{offset: -90, cancelable: true})
        }else if(e==='quem_somos'){
          VueScrollTo.scrollTo('#quem_somos', 1000,{offset: -60, cancelable: true})
        }else if(e==='parceiros'){
          VueScrollTo.scrollTo('#parceiros', 1000,{offset: -60, cancelable: true})
        }else if(e==='contato'){
          VueScrollTo.scrollTo('#contato', 500)
        }

      },
      changeLanguage: function (e) {
        this.$store.dispatch(LANGUAGE,e)
      }

    },
  name: 'App',
  components: {
    Navigation,
    Footer
  }
}
</script>
<style>
.noselect {
-webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
.selectable {
-webkit-touch-callout: text !important; /* iOS Safari */
  -webkit-user-select: text !important; /* Safari */
   -khtml-user-select: text !important; /* Konqueror HTML */
     -moz-user-select: text !important; /* Firefox */
      -ms-user-select: text !important; /* Internet Explorer/Edge */
          user-select: text !important; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
.background{
  background-image: url('./assets/background_zap2_low_low.jpg');
  background-repeat: repeat;

}
.cluttering{
  max-width: 1100px !important;
  margin: 0 auto !important;
  /*
  display: table !important;
  */
}
.verticalLine {
  /*border-left: 1px solid rgba(0,0,0,.12);*/
}
.fullwith{
  max-width: 100% !important;
}
.cardmin{
  min-height: 347px !important;
}
.pointerzoom{
  cursor: zoom-in	 !important;
}

.clutteringNavbar{
  width: 1100px !important;
  max-width: 90vw !important;
  display: table;
  margin: 0 auto !important;
}
.textoJustificado{
  text-align: justify !important;
  text-justify: auto !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue